import * as angular from "angular";
import {IController, IFilterService} from "angular";
import {AdminDialogService} from "../../services/admin-dialogs-service.service";
import {ConfirmDialogService} from "../../../commons/services/confirm-dialog.service";
import {PoliciesAlertsService} from "../../../policies/services/policies-alerts.service";
import {PreferencesDialogService} from "../../../site-preferences/services/preferences-dialogs-service.service";
import {SplitService} from "../../../commons/services/split-service.service";
import {IAMPermissionsService} from "../../../../permission/iamPermissions.service";
import {TeamsRequestsService} from "../../../teams/services/teams-requests.service";
import {UserService} from "../../../../permission/user.service";
import {BranchModel} from "../../../branches/models/branch.model";
import {ContactPersonModel} from "../../../commons/models/contact-person.model";
import {ContactPersonsTableItem} from "../../angular/components/contact-persons-table/contact-persons-table.component";

export class SelfProfileComponent implements IController {
  user: any;
  emailReportNotificationConfigurations?: any[];

  private loading: boolean;
  private isMobile: boolean;
  private branchesRef;
  public hasSiteAccess: boolean;
  public excludedEmailReportTypes?: any[];
  public siteId: string;
  public userTeams: any[];
  public contactsMap: { [branchId: string]: ContactPersonModel };
  public branchesMap: { [branchId: string]: BranchModel };
  public contactsTableItems: ContactPersonsTableItem[];

  /* @ngInject */
  constructor(
    private $log,
    private adminDialogService: AdminDialogService,
    private confirmDialogService: ConfirmDialogService,
    private policiesAlertsService: PoliciesAlertsService,
    private preferencesDialogService: PreferencesDialogService,
    private IAMPermissions: IAMPermissionsService,
    private splitService: SplitService,
    private UserService: UserService,
    private teamsRequestsService: TeamsRequestsService,
    private IamRequests,
    private $branches,
    private $mdMedia
  ) {
    this.siteId = this.splitService.getSiteId();
    this.branchesRef = this.$branches();
  }

  $onInit() {

    // Set up email notification configurations
    if (!this.emailReportNotificationConfigurations) {
      this.emailReportNotificationConfigurations = [];
    }
    this.emailReportNotificationConfigurations = this.emailReportNotificationConfigurations.filter(emailReport => !emailReport.visibleToAdmin);

    // Create excluded email report types array for dialogs
    this.excludedEmailReportTypes = this.emailReportNotificationConfigurations.map(item => item.emailReportType);
    // this.hasSiteAccess = !(this.user.inactiveSites || []).includes(this.siteId);

    if (this.IAMPermissions.hasPermission('teams.list')) {
      this._getUserTeams();
    }

    this.isMobile = !this.$mdMedia('gt-md');

    if (!!this.user.contactBranchIds?.length) {
      this._getContacts();
    }

  }

  onEditPassword(event) {
    this.adminDialogService.editPassword(event, this.user, {})
      .then((editedUser) => {
        this.loading = true;
        return this.IamRequests.updateSelfProfile(this.user.id, {user: editedUser}, this.siteId);
      })
      .then((response) => {
        this.user = response.user || response;
        this.policiesAlertsService.updatePasswordSuccess();
      })
      .catch((error) => {
        if (error) {
          this.policiesAlertsService.updatePasswordError();
          this.$log.error('Failed to update user password @selfProfile@onEditPassword', error);
        } else {
          this.$log.info('Dialog Closed');
        }
      })
      .finally(() => {
        this.loading = false;
      });
  }

  onEditUser(event) {
    this.adminDialogService.editSelfProfile(event, this.user)
      .then((editedUser) => {
        this.loading = true;
        return this.IamRequests.updateSelfProfile(this.user.id, {user: editedUser}, this.siteId);
      })
      .then((response) => {
        this.user = response.user || response;
        this.policiesAlertsService.updateInfoSuccess();
      })
      .catch((error) => {
        if (error) {
          this.policiesAlertsService.updateInfoError();
          this.$log.error('Failed to update self profile @selfProfile@onEditUser', error);
        } else {
          this.$log.info('Dialog Closed');
        }
      })
      .finally(() => {
        this.loading = false;
      });
  }


  onAddContactPerson(event) {
    const contactPerson: ContactPersonModel = {
      email: this.user.email,
      phoneNumber: this.user.phoneNumber,
      name: this.user.fullName || this.user.firstName ? `${this.user.firstName} ${this.user.lastName}` : undefined
    }
    this.adminDialogService.editContactPerson( contactPerson, undefined, this.user.contactBranchIds, event)
      .then(({contact, branchId}: { contact: ContactPersonModel, branchId: string }) => {
        this.loading = true;
        return this.IamRequests.updateBranchContacts(this.user.id, contact, branchId, this.siteId);
      })
      .then((user) => {
        this.user = user;
        if (!!this.user.contactBranchIds?.length) {
          this._getContacts();
        }
      })
      .catch((error) => {
        if (error) {
          this.$log.error('Failed to update branch contacts @selfProfile@onAddContactPerson', error);
        } else {
          this.$log.info('Dialog Closed');
        }
      })
      .finally(() => {
        this.loading = false;
      });
  }

  onDeleteContactPerson(branchId: string) {
    this.confirmDialogService.confirm('Delete Contact', 'Are you sure you want to delete this contact?')
      .then(() => {
        this.loading = true;
        return this.IamRequests.deleteBranchContacts(this.user.id, branchId, this.siteId);
      })
      .then((response) => {
        this.user = response.user || response;
        if (!!this.user.contactBranchIds?.length) {
          this._getContacts();
        } else {
          this.contactsMap = {};
          this.branchesMap = {};
          this.contactsTableItems = [];
        }
      })
      .catch((error) => {
        if (error) {
          this.$log.error('Failed to delete branch contact @selfProfile@onDeleteContactPerson', error);
        } else {
          this.$log.info('Dialog Closed');
        }
      })
      .finally(() => {
        this.loading = false;
      });
  }

  onAddUserReports(event) {
    // For self-profile, we don't have user branches/teams, so pass empty arrays
    this.preferencesDialogService.createEmailReportConfiguration(this.excludedEmailReportTypes, 'Add report', false, true, [], this.userTeams || [])
      .then((emailNotificationConfigurationsCopy) => {
        const payload = {
          emailReportNotificationConfigurations: [...this.emailReportNotificationConfigurations, emailNotificationConfigurationsCopy]
        }
        this.editUserReports(payload);
      })
      .catch(() => {
        // User cancelled or error occurred
        this.$log.info('Add user reports cancelled or failed');
      });
  }

  onEditUserReport(emailNotificationConfiguration, index) {
    // For self-profile, we don't have user branches/teams, so pass empty arrays
    this.preferencesDialogService.editEmailReportConfiguration(emailNotificationConfiguration, this.excludedEmailReportTypes, 'Edit report', false, true, [], this.userTeams || [])
      .then((updatedEmailNotificationConfigurationsCopy) => {
        const emailNotificationConfigurationsCopy = angular.copy(this.emailReportNotificationConfigurations);
        emailNotificationConfigurationsCopy.splice(index, 1, updatedEmailNotificationConfigurationsCopy);

        const payload = {
          emailReportNotificationConfigurations: emailNotificationConfigurationsCopy
        }
        this.editUserReports(payload);
      })
      .catch(() => {
        // User cancelled or error occurred
        this.$log.info('Edit user report cancelled or failed');
      });
  }

  private editUserReports(payload) {
    this.loading = true;


    const fullPayload = {
      user: this.user,
      ...payload
    };

    this.IamRequests.updateSelfProfile(this.user.id, fullPayload, this.siteId)
      .then((response) => {
        // Update the local configurations
        this.emailReportNotificationConfigurations = (response.emailReportNotificationConfigurations || payload.emailReportNotificationConfigurations || [])
          .filter(emailReport => !emailReport.visibleToAdmin);
        this.excludedEmailReportTypes = this.emailReportNotificationConfigurations.map(item => item.emailReportType);
        this.policiesAlertsService.editUserReportsSuccess();
      })
      .catch((error) => {
        this.policiesAlertsService.editUserReportsError();
        this.$log.error('Failed to update user reports @selfProfile@editUserReports', error);
      })
      .finally(() => {
        this.loading = false;
      });
  }

  private _getUserTeams() {
    const currentUser = this.UserService.getCurrentUser();
    this.teamsRequestsService.getTeamMembersByUser(currentUser.id)
      .then((userTeams) => {
        this.userTeams = userTeams;
    })
  }

  private _getContacts() {
    this.branchesRef.$getAll({ids: this.user.contactBranchIds})
      .then((ids) => {
        return this.branchesRef.$asyncValues(this.user.contactBranchIds);
      })
      .then((branches: BranchModel[]) => {
        this.branchesMap = branches.reduce((map, branch) => {
          map[branch.id] = branch;
          return map;
        }, {} as { [branchId: string]: BranchModel });

        this.contactsMap = branches.reduce((map, branch) => {
          const contact = (branch.contactPeople || []).find((contactPerson) => contactPerson.email === this.user.email);
          if (contact) {
            map[branch.id] = contact;
          }
          return map;
        }, {} as { [branchId: string]: ContactPersonModel });

        this.contactsTableItems = Object.keys(this.contactsMap).map((branchId) => ({
          id: branchId,
          branchName: this.branchesMap[branchId]?.name,
          contact: this.contactsMap[branchId]
        }));
      })
  }

}

angular
  .module('bringoz.admin.admins')
  .component('selfProfile', {
    bindings: {
      user: '<',
      emailReportNotificationConfigurations: "<?"
    },
    template: require('./self-profile.html').default,
    controller: SelfProfileComponent
  });
